// The plans, as the website's pricing page shows them. The website is the
// source of truth (voolist repo, src/utils/constants.js: PRICING_PLANS,
// PLAN_MORE_FEATURES and POWER_LISTING_TIERS): when its plans, prices, limits
// or lists change, copy them here so the in-app plans page says the same.

export const PRICING_PLANS = [
  {
    subscription: 'starter',
    price: 19.99,
    annual: Math.round(((12 * 19.99 - 2 * 19.99) / 12) * 10) / 10,
    caption: 'The essentials to sell on every marketplace',
    limits: {
      activeListings: 250,
      inactiveListings: 1000,
      aiCredits: 25,
      accountsPerMarketplace: 1,
    },
    // Each card's short list under its limits (a line ending in ":" is its
    // heading). Starter names the headline features, which every plan has;
    // Pro and Power say what they add, worked out from `limits` and
    // POWER_LISTING_TIERS: check the maths if those change. The rest of the
    // features open under "Every other feature" (PLAN_MORE_FEATURES).
    lists: [
      'Every feature, including:',
      'Cross-list to 11 marketplaces from one form',
      'Sales detection and auto-delist',
      'Bulk cross-listing',
      'One-click import or CSV upload',
      'AI listing writer',
      'Bulk edit, delist and relist',
      'Live chat support',
    ],
  },
  {
    subscription: 'pro',
    price: 29.99,
    annual: Math.round(((12 * 29.99 - 2 * 29.99) / 12) * 10) / 10,
    caption: 'For growing sellers who need speed and automation',
    limits: {
      activeListings: 750,
      inactiveListings: 5000,
      aiCredits: 250,
      accountsPerMarketplace: 2,
    },
    lists: [
      'Everything in Starter, plus:',
      'Two eBay accounts or two Shopify stores',
      '3x the active listings',
      '5x the drafts',
      '10x the AI listings',
    ],
  },
  {
    subscription: 'power',
    price: 49.99,
    annual: Math.round(((12 * 49.99 - 2 * 49.99) / 12) * 10) / 10,
    caption: 'For high-volume sellers and agencies managing large catalogs',
    limits: {
      activeListings: 2000,
      inactiveListings: 10000,
      aiCredits: 500,
      accountsPerMarketplace: 2,
    },
    lists: [
      'Everything in Pro, plus:',
      'Priority sync',
      'Priority support',
      'Room for 2,000 to 10,000+ listings',
      'Up to 1,000 AI listings a month',
    ],
  },
];

// Every other feature, which every plan has too. The plan cards open this
// list under "Every other feature".
export const PLAN_MORE_FEATURES = [
  'Auto offers to eBay watchers',
  'Mark as sold anywhere',
  'Different prices, titles and descriptions per marketplace',
  'Duplicate detection when you import',
  'Schedule listings for later',
  'HTML listing templates and saved presets',
  'Built-in photo editor',
  'Free image hosting',
  'Shipping, return and payment policies',
  'Smart defaults that remember your choices',
  'Tags and labels for your inventory',
  'Shop settings for currency and units',
];

// The Power card's listings picker. Each tier's `id` is the plan sent to
// checkout; Enterprise has no price and opens an email instead.
export const POWER_LISTING_TIERS = [
  {
    id: 'power_2k',
    label: '2K',
    price: 49.99,
    annual: Math.round(((12 * 49.99 - 2 * 49.99) / 12) * 10) / 10,
    activeListings: 2000,
    inactiveListings: 10000,
    accountsPerMarketplace: 2,
    aiCredits: 500,
  },
  {
    id: 'power_5k',
    label: '5K',
    price: 79.99,
    annual: Math.round(((12 * 79.99 - 2 * 79.99) / 12) * 10) / 10,
    activeListings: 5000,
    inactiveListings: 20000,
    accountsPerMarketplace: 3,
    aiCredits: 1000,
  },
  {
    id: 'enterprise',
    label: '10K+',
    price: null,
    annual: null,
    activeListings: null,
    inactiveListings: null,
    accountsPerMarketplace: '5+',
    contactSales: true,
  },
];
